import { render } from "./BaseListLinks.vue?vue&type=template&id=21585141&scoped=true"
import script from "./BaseListLinks.vue?vue&type=script&lang=js"
export * from "./BaseListLinks.vue?vue&type=script&lang=js"

import "./BaseListLinks.vue?vue&type=style&index=0&id=21585141&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21585141"]])

export default __exports__